module.exports = __webpack_public_path__ + "img/1695188992672-hismawati  syahwa cathering.jpg.7d18f3e2.webp";